import React from 'react';
import moment from 'moment';
import fileDownload from 'js-file-download';

import {BaseDialog, Role} from 'dialogs/BaseDialog';
import theme from './Search.scss';
import Header from 'common/Header';
import Input from 'common/Input';
import Select from 'common/Select';
import Table from 'common/Table';
import LogoutTimer from '../LogoutTimer';
import {getMessage as msg} from 'MessageBundle';
import conf from 'configuration.json';
import readIcon from './read.png';
import editIcon from './edit.png';
import ProgressBar from 'common/ProgressBar';
import InfoPanel from "./InfoPanel";
import {floatToString} from 'utils/Number'

const DEFAULT_DATE_VALUE = "TT.MM.JJ";
const EQUAL = "=";
const LESS_THAN = "<";
const GREATER_THAN = ">";
export default class Search extends BaseDialog {

    dateCriteriaNames = [
        'createdFrom',
        'createdTo',
        'completedBySalesFrom',
        'completedBySalesTo'
    ];
    criteriaNames = [
        'complaintNumber',
        'invoiceNumberAny',
        'deliveryNoteNumber',
        'creditNoteNumber',
        'imeiNumber',
        'type',
        'reason',
        'cause',
        'product',
        'debitNoteId',
        'basket',
        ...this.dateCriteriaNames
    ];

    constructor(props) {
        super(props);

        this.state = this.getInitialState();
        // TODO why not to move them to getInitialState()?
        this.state.result = [];
        this.state.searchCount = 0;
        this.state.searchLimitExceed = false;
        this.state.searchDisabled = true;

        this.approvedAmountOpValues = new Map([
            [EQUAL, EQUAL],
            [LESS_THAN, LESS_THAN],
            [GREATER_THAN, GREATER_THAN]
        ]);

        // TODO: return this list from the REST service
        this.baskets = new Map([
            ["Eingang", "Eingang"],
            ["Gegenzeichnen Stufe 1", "Gegenzeichnen Stufe 1"],
            ["Gegenzeichnen Stufe 2", "Gegenzeichnen Stufe 2"],
            ["Gegenzeichnen Stufe 3", "Gegenzeichnen Stufe 3"],
            ["Genehmigt", "Genehmigt"],
            ["Nicht genehmigt", "Nicht genehmigt"],
            ["Wiedervorlage", "Wiedervorlage"],
            ["Wiedervorlage WRS", "Wiedervorlage WRS"],
            ["Buchhalt. Prüfung", "Buchhalt. Prüfung"],
            ["Buchhalt. Eingang", "Buchhalt. Eingang"],
            ["Buchhalt. Abschluss", "Buchhalt. Abschluss"],
            ["Ablage", "Ablage"],
            ["Warten auf Archivierung", "Warten auf Archivierung"],
            ["Archiviert", "Archiviert"],
            ["Fehler bei Archivierung", "Fehler bei Archivierung"]
        ]);
    }

    getAllowedRoles() {
        return [Role.VPQ_OPERATOR];
    }

    componentDidMount() {
        super.init(() => {
            if (this.state.vpqOperator) {
                this.types = new Map();
                this.reasons = new Map();
                this.causes = new Map();
                this.products = new Map();

                for (let type of this.state.complaintTypes) {
                    this.types.set(type.name, type.name);

                    for (let reason of type.reasons) {
                        this.reasons.set(reason.name, reason.name);

                        for (let cause of reason.causes) {
                            this.causes.set(cause.name, cause.name);

                            for (let product of cause.products) {
                                this.products.set(product.name, product.name);
                            }
                        }
                    }
                }

                this.tableStructure = [
                    {
                        label: msg('searchComplaint.actionHeader'), width: '74px', headStyle: theme.columnAction, bodyStyle: theme.columnAction,
                        render: (row) => {
                            return (
                                <div>
                                    <a href="#" title={msg('searchComplaint.readComplaintText')} onClick={this.openComplaint(row, ['readonly'])}>
                                        <img src={readIcon} alt=""/>
                                    </a>
                                    {row.editable ?
                                        <a href="#" title={msg('searchComplaint.editComplaintText')} onClick={this.openComplaint(row)}>
                                            <img src={editIcon} alt=""/>
                                        </a> : null}
                                </div>
                            );
                        }
                    },
                    {
                        label: msg('searchComplaint.createdHeader'), width: '80px',
                        render: (row) => {
                            return moment(row.created).format('DD.MM.YY');
                        }
                    },
                    {
                        label: msg('searchComplaint.complaintNumberHeader'), fullLabel: msg('searchComplaint.complaintNumberHeader.full'),
                        width: '84px', headStyle: theme.columnComplaintNumber, bodyStyle: theme.columnComplaintNumber,
                        render: (row) => {
                            return row.complaintNumber;
                        }
                    },
                    {
                        label: msg('searchComplaint.hvoHeader'), width: '80px', headStyle: theme.columnHvo, bodyStyle: theme.txtRight,
                        render: (row) => {
                            return row.hvo;
                        }
                    },
                    {
                        label: msg('searchComplaint.uvoHeader'), width: '80px', headStyle: theme.columnUvo, bodyStyle: theme.txtRight,
                        render: (row) => {
                            return row.uvo;
                        }
                    },
                    {
                        label: msg('searchComplaint.complaintTypeHeader'), fullLabel: msg('searchComplaint.complaintTypeHeader.full'),
                        width: '80px', headStyle: theme.columnComplaintType, bodyStyle: theme.columnComplaintType,
                        render: (row) => {
                            return <div className={theme.txtOverflow} title={row.type}>{row.type}</div>;
                        }
                    },
                    {
                        label: msg('searchComplaint.amountNetHeader'), fullLabel: msg('searchComplaint.amountNetHeader.full'),
                        width: '110px', bodyStyle: theme.txtRight,
                        render: (row) => {
                            return floatToString(row.requestedAmountNet);
                        }
                    },
                    {
                        label: msg('searchComplaint.amountTotalHeader'), fullLabel: msg('searchComplaint.amountTotalHeader.full'),
                        width: '110px', bodyStyle: theme.txtRight,
                        render: (row) => {
                            const value = floatToString(row.approvedAmountTotal);
                            return <div className={theme.txtOverflow} title={value}>{value}</div>;
                        }
                    },
                    {
                        label: msg('searchComplaint.complaintProductHeader'), width: '110px', headStyle: theme.columnProductType, bodyStyle: theme.columnProductType,
                        render: (row) => {
                            return <div className={theme.txtOverflow} title={row.product}>{row.product}</div>;
                        }
                    },
                    {
                        label: msg('searchComplaint.complaintReasonHeader'), width: '137px', headStyle: theme.columnComplaintReason, bodyStyle: theme.columnComplaintReason,
                        render: (row) => {
                            return <div className={theme.txtOverflow} title={row.reason}>{row.reason}</div>;
                        }
                    },
                    {
                        label: msg('searchComplaint.complaintCauseHeader'), width: '117px', headStyle: theme.columnComplaintCause, bodyStyle: theme.columnComplaintCause,
                        render: (row) => {
                            return <div className={theme.txtOverflow} title={row.cause}>{row.cause}</div>;
                        }
                    },
                    {
                        label: msg('searchComplaint.basketHeader'), width: '96px', headStyle: theme.columnBasket, bodyStyle: theme.columnBasket,
                        render: (row) => {
                            return <div className={theme.txtOverflow} title={row.basket}>{row.basket}</div>;
                        }
                    }
                ];
                this.setState({
                    vo: "", //vo should not be predefined here
                    initialized: true
                })
            } else {
                window.location.href = "/";
            }
        });
    }

    getInitialState = () => {
        return {
            vo: "",
            complaintNumber: "",
            invoiceNumberAny: "",
            deliveryNoteNumber: "",
            creditNoteNumber: "",
            imeiNumber: "",
            type: "",
            reason: "",
            cause: "",
            product: "",
            products: new Map(),
            approvedAmountOp: "=",
            approvedAmount: "",
            debitNoteId: "",
            basket: "",
            createdFrom: DEFAULT_DATE_VALUE,
            createdTo: DEFAULT_DATE_VALUE,
            completedBySalesFrom: DEFAULT_DATE_VALUE,
            completedBySalesTo: DEFAULT_DATE_VALUE,
            result: [],
            processing: false,
            searchLimitExceed:false
        };
    };

    resetComponent = () => {
        this.setState(this.getInitialState());
    };

    handleSearchAttributeChange = (name) => (e) => {
        this.setState({
            [name]: e.target.value,
            searchDisabled: false
        });
    };

    handleSearchComplaints = () => {
        this.setState({
            processing: true,
            result: [],
            searchCount: 0,
            searchLimitExceed: false,
            query: this.createSearchQuery()
        }, () => {
            this.request('get', conf.rest.complaintSearchCountEndpoint).query(this.state.query).send((result) => {
                const {count, searchLimitExceed} = result.body;

                if (searchLimitExceed) {
                    this.setState({
                        processing: false,
                        searchCount: count,
                        searchLimitExceed: true
                    });
                } else {
                    this.handleSearchContinue();
                }
            })
        });
    };

    createSearchQuery = () => {
        let query = {};
        for (let criteria of this.criteriaNames) {
            const value = this.state[criteria];
            // We have to skip unfilled values
            if (value === "" || (this.dateCriteriaNames.indexOf(criteria) >= 0 && !moment(value, "DD.MM.YY", true).isValid())) {
                continue;
            }
            query[criteria] = value;
        }

        if (this.state.approvedAmount !== "") {
            if (this.state.approvedAmountOp === EQUAL) {
                query['approvedAmountTotal'] = this.state.approvedAmount;
            } else if (this.state.approvedAmountOp === GREATER_THAN) {
                query['approvedAmountTotalFrom'] = this.state.approvedAmount;
            } else {
                query['approvedAmountTotalTo'] = this.state.approvedAmount;
            }
        }
        // split vo list and add to query
        if (this.state.vo !== "") {
            let voList = this.state.vo.indexOf(",") !== -1 ? this.state.vo.split(",") : this.state.vo.split(" ");
            query['vo'] = voList.map(vo => vo.trim()).filter(vo => vo !== "");
        }

        return query;
    };

    handleSearchCancel = () => {
        this.setState({
            searchCount: 0,
            searchLimitExceed: false,
            result: [],
            query: undefined
        })
    };

    handleExportComplaints = () => {
        this.setState({processing: true});
        this.request('get', conf.rest.complaintSearchExportEndpoint).query(this.state.query).send((result) => {
            const {content, fileName} = result.body;

            const byteArray = new Uint8Array(this.strToByteArray(content));
            const file = new Blob([byteArray]);
            fileDownload(file, fileName);

            this.setState({processing: false});
        });
    };

    isExportAllowed = () => {
        const searchInitiated = this.state.query;
        const emptyResult = this.state.result.length === 0;
        const searchLimitExceed = this.state.searchLimitExceed;
        return searchInitiated && (!emptyResult || searchLimitExceed);
    };

    handleSearchContinue = () => {
        this.setState({processing: true});
        this.request('get', conf.rest.complaintSearchEndpoint).query(this.state.query).send((result) => {
            this.setState({
                processing: false,
                searchLimitExceed: false,
                result: result.body
            });
        });
    };

    renderSearchResult = () => {
        if (this.state.searchLimitExceed) {
            return (
                <InfoPanel searchCount={this.state.searchCount}/>
            );
        } else {
            return (
                <div className={theme.tblWrap}>
                    <div className={theme.tblWrapInner}>
                        <Table structure={this.tableStructure} value={this.state.result} className={theme.searchResult}/>
                    </div>
                </div>
            );
        }
    };

    getDialog() {
        return (
            <div className={theme.client}>
                <Header value={msg('vprekla.header')}>
                    <h2>{msg('searchComplaint.header')}</h2>
                    <ul>
                        <li>
                            <a href="#">{msg('navigationMenu.helpLnk')}</a>
                        </li>
                        <li>
                            <LogoutTimer timeout={this.state.logoutTimeout} onTimeOver={() => this.logout(this.state.tvppLogoutUrl)}/>
                        </li>
                    </ul>
                </Header>
                <section>
                    <div>
                        <h3>{msg('searchComplaint.searchHeader')}</h3>
                        <Input id="vo-txt" value={this.state.vo} onChange={this.handleSearchAttributeChange("vo")}
                            label={msg('searchComplaint.voLabel')} tooltip={msg('searchComplaint.voTooltip')}
                            className={theme.row + ' ' + theme.txtRight} />
                        <div className={theme.clear}>
                            <div className={theme.col}>
                                <Input id="complaintNumber-txt" value={this.state.complaintNumber} className={theme.row + ' ' + theme.txtRight}
                                    onChange={this.handleSearchAttributeChange("complaintNumber")} label={msg('searchComplaint.complaintNumberLabel')}/>
                                <Input id="invoiceNumber-txt" value={this.state.invoiceNumberAny} className={theme.row + ' ' + theme.txtRight}
                                    onChange={this.handleSearchAttributeChange("invoiceNumberAny")} label={msg('searchComplaint.invoiceNumberLabel')}/>
                                <Input id="deliveryNoteNumber-txt" value={this.state.deliveryNoteNumber} className={theme.row + ' ' + theme.txtRight}
                                    onChange={this.handleSearchAttributeChange("deliveryNoteNumber")} label={msg('searchComplaint.deliveryNoteNumberLabel')}/>
                                <Input id="creditNoteNumber-txt" value={this.state.creditNoteNumber} className={theme.row + ' ' + theme.txtRight}
                                    onChange={this.handleSearchAttributeChange("creditNoteNumber")} label={msg('searchComplaint.creditNoteNumberLabel')}/>
                                <Input id="imeiNumber-txt" value={this.state.imeiNumber} className={theme.row + ' ' + theme.txtRight}
                                    onChange={this.handleSearchAttributeChange("imeiNumber")} label={msg('searchComplaint.imeiNumberLabel')}/>
                            </div>
                            <div className={theme.col + ' ' + theme.colMiddle}>
                                <Select id="type-select" value={this.state.type} onChange={this.handleSearchAttributeChange("type")} className={theme.row}
                                    label={msg('searchComplaint.complaintTypeLabel')} emptyValue={msg('searchComplaint.allValue')} options={this.types}/>
                                <Select id="reason-select" value={this.state.reason} onChange={this.handleSearchAttributeChange("reason")} className={theme.row}
                                    label={msg('searchComplaint.complaintReasonLabel')} emptyValue={msg('searchComplaint.allValue')} options={this.reasons}/>
                                <Select id="cause-select" value={this.state.cause} onChange={this.handleSearchAttributeChange("cause")} className={theme.row}
                                    label={msg('searchComplaint.complaintCauseLabel')} emptyValue={msg('searchComplaint.allValue')} options={this.causes}/>
                                <Select id="product-select" value={this.state.product} onChange={this.handleSearchAttributeChange("product")} className={theme.row}
                                    label={msg('searchComplaint.complaintProductLabel')} emptyValue={msg('searchComplaint.allValue')} options={this.products}/>
                            </div>
                            <div className={theme.col + ' ' + theme.colLast}>
                                <div className={theme.row + ' ' +theme.amountTotal}>
                                    <Select id="approvedAmountTotalOp-select" value={this.state.approvedAmountOp} onChange={this.handleSearchAttributeChange("approvedAmountOp")}
                                        label={msg('searchComplaint.amountTotalLabel')} allowEmpty={false} options={this.approvedAmountOpValues}/>
                                    <Input id="approvedAmountTotalId-txt" value={this.state.approvedAmount} onChange={this.handleSearchAttributeChange("approvedAmount")}
                                        allowedSymbols={"^[0-9.,]$"}/>
                                </div>

                                <Input id="debitNoteId-txt" value={this.state.debitNoteId} onChange={this.handleSearchAttributeChange("debitNoteId")}
                                    label={msg('searchComplaint.debitNoteIdLabel')} className={theme.row}/>
                                <Select id="basket-select" value={this.state.basket} onChange={this.handleSearchAttributeChange("basket")}
                                    label={msg('searchComplaint.basketLabel')} emptyValue={msg('searchComplaint.allValue')} options={this.baskets} className={theme.row}/>

                                <div className={theme.row + ' ' + theme.rowPeriod}>
                                    <span>{msg('searchComplaint.createdLabel')}</span>
                                    <Input id="createdFrom-txt" value={this.state.createdFrom} onChange={this.handleSearchAttributeChange("createdFrom")}
                                        label={msg('searchComplaint.fromLabel')} maxLength={8}/>
                                    <Input id="createdTo-txt" value={this.state.createdTo} onChange={this.handleSearchAttributeChange("createdTo")}
                                        label={msg('searchComplaint.toLabel')} maxLength={8}/>
                                </div>

                                <div className={theme.row + ' ' + theme.rowPeriod}>
                                    <span>{msg('searchComplaint.completedBySalesLabel')}</span>
                                    <Input id="completedBySalesFrom-txt" value={this.state.completedBySalesFrom} onChange={this.handleSearchAttributeChange("completedBySalesFrom")}
                                        label={msg('searchComplaint.fromLabel')} maxLength={8}/>
                                    <Input id="completedBySalesTo-txt" value={this.state.completedBySalesTo} onChange={this.handleSearchAttributeChange("completedBySalesTo")}
                                        label={msg('searchComplaint.toLabel')} maxLength={8}/>
                                </div>
                            </div>
                        </div>

                        <div className={theme.btnGroupSearch}>
                            <button id="reset-btn" onClick={this.resetComponent}>{msg('searchComplaint.resetButton')}</button>
                            <button id="search-btn" className={theme.accent} onClick={this.handleSearchComplaints} disabled={this.state.searchDisabled}>
                                {msg('searchComplaint.searchButton')}
                            </button>
                        </div>
                    </div>
                    <div>
                        <h3>{msg('searchComplaint.resultHeader')}</h3>
                        {this.renderSearchResult()}
                        <div className={theme.btnGroupSearchResult}>
                            <button id="continue-btn" onClick={this.handleSearchContinue} disabled={!this.state.query} hidden={!this.state.searchLimitExceed}>
                                {msg('searchComplaint.continueButton')}
                            </button>
                            <button id="cancel-btn" onClick={this.handleSearchCancel} disabled={!this.state.query} hidden={!this.state.searchLimitExceed}>
                                {msg('searchComplaint.cancelButton')}
                            </button>
                            <div>
                                <button id="export-btn" onClick={this.handleExportComplaints} disabled={!this.isExportAllowed()}>
                                    {msg('searchComplaint.exportButton')}
                                </button>
                                <button id="close-btn" onClick={this.closeWindow}>
                                    {msg('searchComplaint.closeButton')}
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
                <ProgressBar hidden={!this.state.processing} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Search/index.js